import { IProductItemViewModel } from 'Scripts/Types/Litium';

import ProductCardColors from 'Components/ProductCardColors';
import WishListButton from 'Components/WishListButton';

interface ProductCardInfoProps {
    url: IProductItemViewModel['url'];
    priceVM?: IProductItemViewModel['priceVM'];
    name?: IProductItemViewModel['name'];
    sizes: IProductItemViewModel['productFilters']['sizes'];
    colors: IProductItemViewModel['productFilters']['colors'];
    isOnWishList: IProductItemViewModel['isOnWishList'];
    enabledWishlist: IProductItemViewModel['enabledWishlist'];
    id: IProductItemViewModel['id'];
    showSizes?: boolean;
    isGiftCard: boolean;
    wishListIconText?: string;
}

const ProductCardInfo = ({
    colors,
    sizes,
    url,
    priceVM,
    name,
    isOnWishList,
    enabledWishlist,
    id,
    showSizes = true,
    isGiftCard,
    wishListIconText,
}: ProductCardInfoProps) => {
    const campaignPrice = priceVM?.campaignPrice;
    const clubPrice = priceVM?.clubPrice;
    const basePrice = priceVM?.basePrice;
    const buyXPrice = priceVM?.buyXCampaigPrice;
    const buyXPricePerUnitText = priceVM?.buyXCampaignPricePerUnitText;

    return (
        <>
            <div className="mb-3.5 flex w-full items-center justify-between gap-1">
                <ProductCardColors colors={colors} url={url} />
                {enabledWishlist && (
                    <WishListButton
                        enabledWishlist={enabledWishlist}
                        isOnWishList={isOnWishList}
                        id={id}
                        stroke="1"
                        wishListIconText={wishListIconText}
                    />
                )}
            </div>

            <div className="flex flex-col">
                <p className="mb-1 font-roboto text-sm font-light text-black lg:text-base">
                    {name}
                </p>
                {!isGiftCard && (
                    <ul className="mb-2 flex flex-col flex-wrap">
                        {clubPrice?.formattedPrice.length > 0 && (
                            <li
                                style={
                                    {
                                        '--hex-text-color':
                                            clubPrice?.priceListColorCode,
                                    } as React.CSSProperties
                                }
                                className="font-roboto text-base font-normal leading-normal text-[var(--hex-text-color)] lg:text-lg"
                            >
                                <span>{clubPrice?.name} </span>
                                {clubPrice?.formattedPrice}
                            </li>
                        )}
                        {campaignPrice?.formattedPrice.length > 0 && (
                            <li
                                style={
                                    {
                                        '--hex-text-color':
                                            campaignPrice?.priceListColorCode,
                                    } as React.CSSProperties
                                }
                                className="font-roboto text-base font-normal leading-normal text-[var(--hex-text-color)] lg:text-lg"
                            >
                                <span>{campaignPrice?.name} </span>
                                {campaignPrice?.formattedPrice}
                            </li>
                        )}
                        {buyXPrice?.formattedPrice.length > 0 && (
                            <li
                                style={
                                    {
                                        '--hex-text-color':
                                            buyXPrice?.priceListColorCode,
                                    } as React.CSSProperties
                                }
                                className="font-roboto text-base font-normal leading-normal text-[var(--hex-text-color)] lg:text-lg"
                            >
                                <span>{buyXPrice?.name} </span>
                                <span>{buyXPrice?.formattedPrice} </span>
                                {buyXPricePerUnitText && buyXPricePerUnitText}
                            </li>
                        )}
                        {basePrice?.formattedPrice.length > 0 && (
                            <li
                                style={
                                    {
                                        '--hex-text-color':
                                            basePrice?.priceListColorCode,
                                    } as React.CSSProperties
                                }
                                className="font-roboto text-sm font-normal leading-normal text-[var(--hex-text-color)] lg:text-base"
                            >
                                <span>{basePrice?.name} </span>
                                {basePrice?.formattedPrice}
                            </li>
                        )}
                    </ul>
                )}
                {showSizes && (
                    <ul className="flex flex-wrap gap-x-2 lg:gap-x-6 lg:gap-y-2">
                        {sizes?.map((size, index) => (
                            <li key={index}>
                                <a
                                    href={`${size.url}?selectedSize=true`}
                                    className={`relative flex h-6 min-w-5 items-center justify-center pr-1 font-roboto text-xs font-light text-black lg:text-sm xl:text-base ${
                                        !size.enabled &&
                                        'before:absolute before:top-2.5 before:h-[2px] before:w-[80%] before:bg-black'
                                    } `}
                                >
                                    {size.title}
                                </a>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </>
    );
};

export default ProductCardInfo;
